var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisEnhanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.3 18.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3b5ca9;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.17,11.19c1.18,0,2.13.95,2.13,2.13v.81h0c-.04.92-.29,2.07-1.32,3.01-1.13,1.03-3.07,1.7-6.32,1.7s-5.2-.67-6.32-1.7C.3,16.2.05,15.05,0,14.13h0v-.81c0-1.18.95-2.13,2.13-2.13h11.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.53,1.18c-.98,0-1.77.79-1.77,1.77v4.71c0,.98.79,1.77,1.77,1.77h8.24c.98,0,1.77-.79,1.77-1.77V2.94c0-.98-.79-1.77-1.77-1.77h-3.53v-.59c0-.36-.26-.59-.59-.59s-.59.27-.59.59v.59h-3.53ZM4.12,5.3c0-.65.53-1.18,1.18-1.18s1.18.53,1.18,1.18-.53,1.18-1.18,1.18-1.18-.53-1.18-1.18ZM8.83,5.3c0-.65.53-1.18,1.18-1.18s1.18.53,1.18,1.18-.53,1.18-1.18,1.18-1.18-.53-1.18-1.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisEnhanced);
export default __webpack_public_path__ + "static/media/analysis-enhanced.55972998f618cbe5da6dc77aac0b2e60.svg";
export { ForwardRef as ReactComponent };